import { Typography } from '@material-ui/core';
import { IOrderDetailItems } from '../../context/orders';
import useStyles from './styles';
import React, { FC } from 'react';
import Note, { NoteType } from '@src/shared/components/Note';

export const OrderDetailCardItems: FC<IOrderDetailItems> = (items) => {
  const classes = useStyles();
  const orderAdditions = items.additions
    .map((addition) => {
      return addition.name;
    })
    .join(',');

  return (
    <>
      <div className={classes.orderDetailCardItemWrapper}>
        <div className={classes.orderDetailCardItemCount}>
          <Typography variant="body1" className="body_large_bold">
            {items.quantity}
          </Typography>
        </div>
        <div className={classes.orderDetailCardItemContent}>
          <Typography variant="body1" className="body_large">
            {items.name}
          </Typography>
          <Typography variant="caption" className="caption">
            {orderAdditions}
          </Typography>
        </div>
      </div>
      <div className={classes.orderDetailCardItemBadge}>
        
        {items.comment ? (
          <Note useTranslationVariables={false} note={items.comment} align="left" type={NoteType.Default} fontSize='xsmall' />
        ) : null}
      </div>
    </>
  );
};
